import { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router';

import { toast } from '@app-evolution-cms/element-ui';

import { ROUTE } from '../route';

interface ProtectedRouteProps {
  fallbackPath?: string;
  hasPermission: boolean;
}

export function ProtectedRoute({
  children,
  fallbackPath = ROUTE.root,
  hasPermission,
}: PropsWithChildren<ProtectedRouteProps>) {
  if (!hasPermission) {
    toast({
      type: 'warning',
      description: 'No tienes permisos para acceder a esta ruta',
    });
    return <Navigate to={fallbackPath} replace />;
  }

  return children ? children : <Outlet />;
}
